
import { Dialog, DialogContent, IconButton, Typography, Toolbar, AppBar, Stack, Box, Button } from "@mui/material"
import { Close } from '@mui/icons-material';
import { Form, TextInput, useGetIdentity, useGetOne, useNotify, useRedirect, useTranslate } from "react-admin"
import { CreateInvoiceReminderCommand, UserReadModel } from "../../GeneratedClients/FreeBillApi"
import { useEffect, useState } from "react"
import { useMutation } from "react-query";
import { apiService } from "../../apiService"

interface IProps {
  recordIds: string[]
}

const CreateInvoiceReminderButton = ({recordIds}: IProps) => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  //@ts-ignore
  const { data: user, isLoading: userLoading} = useGetOne<UserReadModel>("users", {id: identity?.id}, {enabled: !identityLoading})
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [initialRecord, setInitialRecord] = useState<{subject?: string, message?: string}>()
  const [open, setOpen] = useState<boolean>(false)
  const { mutate, isLoading } = useMutation((command: CreateInvoiceReminderCommand) => 
    apiService.InvoicesApi.createInvoiceReminder({createInvoiceReminderCommand: command, id: command.id!}),
    {
      onSuccess: (data) => {
        notify(translate("resources.invoices.notifications.invoiceReminderCreated"))
        redirect("list", "invoiceReminders")
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  useEffect(() => {
    setInitialRecord({subject:`Zahlungserinnerung / Mahnung`, message:""})
  }, [])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleCloseDialog = () => {
    setOpen(false)
  }

  const handleSubmit = (fieldValues: {subject?: string, message?: string}) => {
    recordIds.forEach(recordId => {
      const command: CreateInvoiceReminderCommand = {
        id: recordId, 
        subject: fieldValues.subject,
        message: fieldValues.message, 
        userId: user?.id
      }
      mutate(command)
    })
  }

  if(identityLoading || userLoading) return null

  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
      >
        {translate('resources.invoices.actions.createInvoiceReminder')}
      </Button>
      <Dialog 
        open={open}
        onClose={handleCloseDialog}
        fullScreen
      >
        <Form record={initialRecord} onSubmit={handleSubmit}>
          <AppBar sx={{position: 'relative'}}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseDialog}
              >
                <Close />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component={'div'} variant="h6" color={"inherit"}>
                {translate("resources.invoices.dialogs.createInvoiceReminderBulk", {smart_count: recordIds.length})}
              </Typography>
              <Button variant="contained" color="success" autoFocus type="submit" disabled={isLoading} >{translate('resources.invoices.actions.createInvoiceReminderBulk', {smart_count: recordIds.length})}</Button>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Stack px={6} py={2} spacing={0}>
              <Box>
                <TextInput 
                  sx={{m:0}} 
                  size="small" 
                  fullWidth 
                  source="subject" 
                  label={`Betreff`}
                />
              </Box>
              <Box>
                <TextInput 
                  label={'Nachricht'}
                  size="small" 
                  source="message"
                  sx={{whiteSpace: 'pre-line'}}
                  fullWidth
                  multiline
                  rows={12}
                />
              </Box>
            </Stack>
          </DialogContent>
        </Form>
      </Dialog>
    </>
  )
}

export default CreateInvoiceReminderButton